export const SWEATSHIRT_PRICE = 3000;
export const TSHIRT_PRICE = 2000;
export const CANCELLATION_PROTECTION_PERCENTAGE = 15;
export const BLACKLISTED_EO_IDS = ['27866', '21986'];
export const BLACKLISTED_EVENT_IDS = [
  17856,
  17979,
  134005,
  181125,
  187203,
  187452,
  187604,
];

export const BOOKING_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUBMITTING_FIELDS: 'SUBMITTING_FIELDS',
  FIELDS_COMPLETED: 'FIELDS_COMPLETED',
  SUBMITTING_PAYMENT: 'SUBMITTING_PAYMENT',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
};

export const EXTERNAL_PROVIDER_LOGIN_WALL_POSITION = {
  BEFORE_FORM: 'BEFORE_FORM',
  AFTER_FORM: 'AFTER_FORM',
};

export const APPAREL_SIZES = [
  { type: 'SMALL', text: 'S' },
  { type: 'MEDIUM', text: 'M' },
  { type: 'LARGE', text: 'L' },
  { type: 'XLARGE', text: 'XL' },
];

export const VALIDATION_ERROR_MESSAGE =
  'Please check all fields have been completed before continuing.';
export const CREATE_BOOKING_ERROR_MESSAGE =
  'Something went wrong, please check all the field have the correct values';
export const DEFAULT_ERROR_MESSAGE = '';

// Ideally we should be using the LABEL field not the ID field here
// Please don't add any more or rely on these anywhere else
// Tom to fix this properly post-Cambridge

export const TICKET_BUYER_HEADING_FIELD_ID = '59c26cbfed1f6800140c1827';
export const IS_PARTICIPANT_FIELD_ID = '59c26cbfed1f6800140d109a';
export const TICKET_BUYER_FIRST_NAME_FIELD_ID = '59c26cbfed1f6800140c1826';
export const TICKET_BUYER_SURNAME_FIELD_ID = '59c26cbfed1f6800140c1825';
export const PARTICIPANT_HEADING_FIELD_ID = '59c26cbfed1f6800140c1812';
export const PARTICIPANT_FIRST_NAME_FIELD_ID = '59c26cbfed1f6800140c1811';
export const PARTICIPANT_SURNAME_FIELD_ID = '59c26cbfed1f6800140c1810';
export const PARTICIPANT_EMAIL_FIELD_ID = '59c26cbfed1f6800140c180d';
export const PARTICIPANT_PHONE_FIELD_ID = '59c26cbfed1f6800140c180c';
export const PARTICIPANT_ADDRESS_FIELD_ID = '59c26cbfed1f6800140c1805';
export const PARTICIPANT_EMAIL_CONFIRMATION_FIELD_ID =
  '59c27cbffd1c6804140d1835';
export const PARTICIPANT_GENDER_FIELD_ID = '59c26cbfed1f6800140c180f';
export const PARTICIPANT_DATE_OF_BIRTH_FIELD_ID = '59c26cbfed1f6800140c180e';
export const PARTICIPANT_MEDICAL_FIELD_ID = '59c26cbfed1f6800140c1813';
export const PARTICIPANT_T_SHIRT_FIELD_ID = '59c26cbfed1f6800140c1814';
export const ORGANISER_OPT_IN = '59c26cbfed1f6800140c1830';

export const GROUP_EMERGENCY_CONTACT_NAME_FIELD_ID = '59c26cbfed1f6800140c1803';
export const GROUP_EMERGENCY_CONTACT_PHONE_FIELD_ID =
  '59c26cbfed1f6800140c1802';
export const GROUP_EMERGENCY_CONTACT_RELATIONSHIP = '59c26cbfed1f6800140c1821';

export const DEFAULT_INJURY_PROTECTION_MESSAGE =
  "If you withdraw due to injury we'll refund you up until 4 days before the event.";

export const TICKET_BUYER_FIELDS = [
  TICKET_BUYER_HEADING_FIELD_ID,
  TICKET_BUYER_FIRST_NAME_FIELD_ID,
  TICKET_BUYER_SURNAME_FIELD_ID,
  IS_PARTICIPANT_FIELD_ID,
];

export const HIDDEN_TICKET_BUYER_FIELD_MAPPING = {
  [PARTICIPANT_FIRST_NAME_FIELD_ID]: TICKET_BUYER_FIRST_NAME_FIELD_ID,
  [PARTICIPANT_SURNAME_FIELD_ID]: TICKET_BUYER_SURNAME_FIELD_ID,
};

// TODO: this is horrible but the easiest for now
export const HIDDEN_TICKET_BUYER_FIELDS = [
  {
    id: IS_PARTICIPANT_FIELD_ID,
    type: 'RADIO_BUTTONS',
    value: "I'm booking for myself",
  },
];
export const BUYER_NOT_PARTICIPANT_FIELDS = [
  PARTICIPANT_HEADING_FIELD_ID,
  PARTICIPANT_FIRST_NAME_FIELD_ID,
  PARTICIPANT_SURNAME_FIELD_ID,
];
export const GROUP_EMERGENCY_FIELDS = [
  GROUP_EMERGENCY_CONTACT_NAME_FIELD_ID,
  GROUP_EMERGENCY_CONTACT_PHONE_FIELD_ID,
  GROUP_EMERGENCY_CONTACT_RELATIONSHIP,
];

export const PAYMENT_PROVIDER = {
  UBIO: 'UBIO',
  STRIPE: 'STRIPE',
};

export const DYAMIC_CHECKOUT_STATE = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  AWAITING_TDS: 'AWAITING_TDS',
};

export const PAYMENT_METHOD_NAME = {
  APPLE_PAY: 'applePay',
  GOOGLE_PAY: 'googlePay',
  CARD: 'card',
};
